import script from "./PremiumTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PremiumTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./PremiumTemplate.vue?vue&type=style&index=0&id=3bf1d32c&lang=css"

const __exports__ = script;

export default __exports__